import React from "react";
import styled from "styled-components";
import { Btns, ButtonL, Content, Section, TextDiv } from "../../styles/Common";
import { Container } from "../../styles/Common";
import { ReactComponent as IcoBack } from "../../styles/images/ico_back.svg";
import ViewTermsOfUseText from "../signup/ViewTermsOfUseText";

const ViewModal = ({ title, setAgreements, setViewMode, target, content }) => {
  const returnTitle = (target) => {
    let res;
    switch (target) {
      case "age":
        res = (
          <h3>
            만 14세 이상 확인 <span className="col">[필수]</span>
          </h3>
        );
        break;
      case "service":
        res = (
          <h3>
            서비스 이용 약관 동의 <span className="col">[필수]</span>
          </h3>
        );
        break;
      case "privacyPolicy":
        res = (
          <h3>
            개인정보 처리방침 동의 <span className="col">[필수]</span>
          </h3>
        );
        break;
      case "privacyConsignment":
        res = (
          <h3>
            개인정보처리 위탁 동의 <span className="col">[필수]</span>
          </h3>
        );
        break;
      case "marketing":
        res = (
          <h3>
            마케팅 수신 동의 <span className="col">[선택]</span>
          </h3>
        );
        break;
      case "eulaAge":
        res = (
          <h3>
            만 14세 이상 확인 <span className="col">[필수]</span>
          </h3>
        );
        break;
      case "eulaTerms":
        res = (
          <h3>
            서비스 이용 약관 동의 <span className="col">[필수]</span>
          </h3>
        );
        break;
      case "eulaPrivacy":
        res = (
          <h3>
            개인정보 처리방침 동의 <span className="col">[필수]</span>
          </h3>
        );
        break;
      case "eula3rd":
        res = (
          <h3>
            개인정보처리 위탁 동의 <span className="col">[필수]</span>
          </h3>
        );
        break;
      case "eulaMarketing":
        res = (
          <h3>
            마케팅 수신 동의 <span className="col">[선택]</span>
          </h3>
        );
        break;
      case "toPartner":
        res = (
          <h3>
            운영사가 제휴사에게 제공 <span className="col">[필수]</span>
          </h3>
        );
        break;
      case "toCompany":
        res = (
          <h3>
            제휴사가 운영사에게 제공 <span className="col">[필수]</span>
          </h3>
        );
        break;
      default:
        return "title";
    }
    return res;
  };

  function convertToHTML(text) {
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  }

  return (
    <ViewTermsOfUseWrap>
      <HeaderWrap>
        <Container>
          <header>
            <button
              onClick={() => {
                setViewMode(false);
              }}
            >
              <IcoBack />
            </button>
            <h2>{title}</h2>
            <div></div>
          </header>
        </Container>
      </HeaderWrap>
      <main>
        <Section>
          <Content>
            <TextDiv>{returnTitle(target)}</TextDiv>
            <Detail>
              {content ? (
                <>
                  {target == "toPartner" && (
                    <p>{convertToHTML(content?.opEula)}</p>
                  )}

                  {target == "toCompany" && (
                    <p>{convertToHTML(content?.opEula)}</p>
                  )}
                </>
              ) : (
                <ViewTermsOfUseText target={target} />
              )}
            </Detail>
          </Content>
          <Btns>
            <ButtonL
              onClick={() => {
                setAgreements((prev) => ({ ...prev, [target]: true }));
                setViewMode(false);
              }}
            >
              동의
            </ButtonL>
          </Btns>
        </Section>
      </main>
    </ViewTermsOfUseWrap>
  );
};

export default ViewModal;

const ViewTermsOfUseWrap = styled.div`
  width: 100%;
  height: 100vh;
  top: 0;
  position: fixed;
  z-index: 999999;
  background-color: ${({ theme }) => theme.color.purple_bg};
`;
const HeaderWrap = styled.div`
  header {
    height: 6.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
    position: relative;
  }

  h2 {
    font-family: NanumSquareEB;
    font-size: 2rem;
    text-align: center;
    line-height: normal;
    color: ${({ theme }) => theme.color.purple_primary};
  }

  button {
    background-color: transparent;
    position: absolute;
    margin: auto;
    left: 2rem;
    top: 0;
    bottom: 0;
  }
`;
const Detail = styled.div`
  margin-top: 5rem;
  height: calc(100vh - 32rem);
  overflow: scroll;
`;
